import repository from "../Repository";

export default {
  async list(screenId, payload) {
    return await repository.post("oil_info", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("oil_ope", payload, {
      headers: {
        s: screenId
      }
    });
  }
};
